export default __webpack_public_path__ + "static/main-logo-5ec060b385d7925c9e8f714a4c5fa896.png";